// extracted by mini-css-extract-plugin
export default {"description":"StudentsViewing_description__XtwUv","wrapper":"StudentsViewing_wrapper__QNRdj"};